import { useCallback, useState } from 'react';

import { useApiContext } from 'context/ApiContext';

import { ITIL_TRANSLATION_TYPE_BY_SCOPE } from '../constants';
import type { BulkItilValidationResult } from '../types';
import { fetchItilTranslationPreferApi } from '../translationCache';

export function useValidateBulkItilExport() {
  const { itilGenius } = useApiContext();
  const [isValidating, setIsValidating] = useState(false);

  const validateTickets = useCallback(
    async (ticketIds: number[]): Promise<BulkItilValidationResult[]> => {
      setIsValidating(true);
      try {
        const results = await Promise.all(
          ticketIds.map(async (ticketId) => {
            const stored = await fetchItilTranslationPreferApi(
              itilGenius,
              ticketId,
              'description',
              ITIL_TRANSLATION_TYPE_BY_SCOPE.description
            );
            return { ticketId, hasTranslation: !!stored?.trim() };
          })
        );
        return results;
      } finally {
        setIsValidating(false);
      }
    },
    [itilGenius]
  );

  return { validateTickets, isValidating };
}
